/**
 * Document metadata interface for parsed documents
 *//**
 * Content action types for document nodes
 */export let ContentActionType=/*#__PURE__*/function(ContentActionType){ContentActionType["PLAY"]="play";ContentActionType["EXPAND"]="expand";ContentActionType["QUIZ"]="quiz";ContentActionType["EXPLAIN"]="explain";ContentActionType["RELATE"]="relate";ContentActionType["PRACTICE"]="practice";return ContentActionType;}({});/**
 * Content action interface
 *//**
 * Content chunk interface for document segmentation
 *//**
 * Base interface for all node data types
 *//**
 * Content node data interface extending BaseNodeData
 * Represents a document chunk transformed into a learning node
 *//**
 * JSON structure node data for structured data from JSON files
 *//**
 * Document upload result
 *//**
 * Document processing options
 *//**
 * Type guards
 */export function isContentNodeData(data){return data.nodeType==='content';}export function isJsonNodeData(data){return data.nodeType==='json';}/**
 * Default content actions
 */export const DEFAULT_CONTENT_ACTIONS=[{type:ContentActionType.PLAY,label:'Play',icon:'▶️',description:'Play an interactive activity based on this content',enabled:true},{type:ContentActionType.EXPAND,label:'Expand',icon:'🔍',description:'Get more detailed explanation',enabled:true},{type:ContentActionType.QUIZ,label:'Quiz Me',icon:'❓',description:'Test your understanding',enabled:true},{type:ContentActionType.EXPLAIN,label:'Explain',icon:'💡',description:'Break down complex concepts',enabled:true},{type:ContentActionType.RELATE,label:'Related Topics',icon:'🔗',description:'Find related content',enabled:true},{type:ContentActionType.PRACTICE,label:'Practice',icon:'✏️',description:'Apply what you learned',enabled:true}];